export enum SpcType {
    country = 1,
    market = 2
}
